module.exports = __webpack_public_path__ + "static/media/cocktails.29f5e741.jpeg";